import { Routes, Route } from "react-router-dom";
import { AuthGuard } from "./components/layout/AuthGuard";
import { Layout } from "./components/layout/Layout";
import { Login } from "./pages/Login";
import { Signup } from "./pages/Signup";
import { Landing } from "./pages/Landing";
import { Onboarding } from "./pages/Onboarding";
import { Brand } from "./pages/Brand";
import { Dashboard } from "./pages/Dashboard";
import { Billing } from "./pages/Billing";
import { Ideas } from "./pages/Ideas";
import { Chat } from "./pages/Chat";
import { Review } from "./pages/Review";
import { Performance } from "./pages/Performance";
import { Usage } from "./pages/Usage";
import { Playbooks } from "./pages/Playbooks";
import { Skills } from "./pages/Skills";
import { FamilyWoven } from "./pages/FamilyWoven";

function Placeholder({ name }: { name: string }) {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <h1 className="text-2xl font-semibold text-slate-400">{name}</h1>
    </div>
  );
}

export function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<Landing />} />
      <Route path="/family-woven" element={<FamilyWoven />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />

      {/* Protected routes */}
      <Route
        element={
          <AuthGuard>
            <Layout />
          </AuthGuard>
        }
      >
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/ideas/:runId" element={<Ideas />} />
        <Route path="/chat/:threadId" element={<Chat />} />
        <Route path="/review/:runId" element={<Review />} />
        <Route path="/performance/:runId" element={<Performance />} />
        <Route path="/brand" element={<Brand />} />
        <Route path="/connections" element={<Placeholder name="Connections" />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/usage" element={<Usage />} />
        <Route path="/playbooks" element={<Playbooks />} />
        <Route path="/skills/:threadId" element={<Skills />} />
        <Route path="/settings" element={<Placeholder name="Settings" />} />
      </Route>
    </Routes>
  );
}
